import { MultipleChoiceOption } from "./multipleChoiceOption";
import { MultipleChoiceQuiz } from "./multipleChoiceQuiz";
export class NumberMultipleChoiceQuiz extends MultipleChoiceQuiz {
    getQuestion() {
        return this._data.question;
    }
    getOptions() {
        let options = new Array();
        let optionIDs = this._data.optionIDs;
        for (let optionID of optionIDs) {
            options.push(this.getMultipleChoiceOption(optionID));
        }
        if (this._isRandomize) {
            options.sort(() => Math.random() - 0.5);
        }
        return options;
    }
    getMultipleChoiceOption(optionID) {
        if (!this._isRandomize) {
            switch (optionID) {
                case "negative":
                    return new MultipleChoiceOption("negative", "-1.23", false, "Valid: Negative and decimal points are allowed.");
                case "invalidZero":
                    return new MultipleChoiceOption("invalidZero", "0123", true, "Invalid: Do no precede numbers without decimals with 0.");
                case "validZero":
                    return new MultipleChoiceOption("validZero", "0.123", false, "Valid: May precede numbers with decimals with 0.");
                case "scientific":
                    return new MultipleChoiceOption("scientific", "1e2", false, "Valid: Scientific notation. Equal to: 1*10^2.");
                case "comma":
                    return new MultipleChoiceOption("comma", "1,234", true, "Invalid: Do not include commas.");
                case "notANumber":
                    return new MultipleChoiceOption("notANumber", "NaN", false, "Valid: Represents Not-a-Number.");
            }
        }
        else {
            switch (optionID) {
                case "negative":
                    return new MultipleChoiceOption("negative", "-" + this.getRandomRange(0, 999) + "." + this.getRandomRange(0, 999), false, "Valid: Negative and decimal points are allowed.");
                case "invalidZero":
                    return new MultipleChoiceOption("invalidZero", "0" + this.getRandomRange(0, 999), true, "Invalid: Do no precede numbers without decimals with 0.");
                case "validZero":
                    return new MultipleChoiceOption("validZero", "0." + this.getRandomRange(0, 999), false, "Valid: May precede numbers with decimals with 0.");
                case "scientific":
                    const base = this.getRandomRange(-999, 15);
                    const exponent = this.getRandomRange(-999, 15);
                    return new MultipleChoiceOption("scientific", base + "e" + exponent, false, "Valid: Scientific notation. Equal to: " + base + "*10^" + exponent + ".");
                case "comma":
                    return new MultipleChoiceOption("comma", this.getRandomRange(-999, 999) + "," + this.getRandomRange(0, 999), true, "Invalid: Do not include commas.");
                case "notANumber":
                    return new MultipleChoiceOption("notANumber", "NaN", false, "Valid: Represents Not-a-Number.");
            }
        }
        throw new Error("Unhandled optionName: " + optionID);
    }
    getRandomRange(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }
}
